module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if(locals.showLoader) { 
    ; __append(" ")
    ;  if(locals.type == 'spin') { 
    ; __append(" <div class=\"sk-fading-circle\"> <div class=\"sk-circle1 sk-circle\"></div> <div class=\"sk-circle2 sk-circle\"></div> <div class=\"sk-circle3 sk-circle\"></div> <div class=\"sk-circle4 sk-circle\"></div> <div class=\"sk-circle5 sk-circle\"></div> <div class=\"sk-circle6 sk-circle\"></div> <div class=\"sk-circle7 sk-circle\"></div> <div class=\"sk-circle8 sk-circle\"></div> <div class=\"sk-circle9 sk-circle\"></div> <div class=\"sk-circle10 sk-circle\"></div> <div class=\"sk-circle11 sk-circle\"></div> <div class=\"sk-circle12 sk-circle\"></div> </div> ")
    ;  } else if(locals.type == 'flat'){ 
    ; __append(" <div class=\"sk-three-bounce\"> <div class=\"sk-child sk-bounce1\"></div> <div class=\"sk-child sk-bounce2\"></div> <div class=\"sk-child sk-bounce3\"></div> </div> ")
    ;  } 
    ; __append(" ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/loader.ejs
// module id = 853
// module chunks = 1